import React, { useState } from "react";
import sliderInner from '../assets/images/sliderInner.jpg';
import LineChart from "../Components/LineChart"
import { GoDotFill } from "react-icons/go";
import { PiExportBold } from "react-icons/pi";
import StateList from "../helper/State_List.json";
import DistrictList from "../helper/District_List.json";
import axiosConn from "config/axiosConn";
import { useNavigate } from "react-router-dom";

function ImpactEnergy() {
  const [financialYear, setFinancialYear] = useState('');
  const [school_name, setSchoolName] = useState('');
  const [stateID, setStateID] = useState('');
  const [state, setStateName] = useState('');
  const [district, setDistrictName] = useState('');
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [filteredSchool, setFilteredSchool] = useState([]);
  const navigate = useNavigate();


  const handleSelectState = (data) => {
    setStateID(data);
    setFilteredSchool([])
    let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
    let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
    setFilterDistrict(filterdistrictList);
    setStateName(StateName);
    getSchoolList({ state_id: data })
  }

  const handleSelectDistrict = async (value) => {
    setFilteredSchool([])
    setDistrictName(value)
    let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
    getSchoolList({ state_id: stateID, district_id: districtid })
  }

  const getSchoolList = async (data) => {
    try {
      let response = await axiosConn('post', 'get-school-filter', data)
      if (response.data.status === 'success') {
        setFilteredSchool(response.data.result)
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleSubmit = async (data) => {
    try {
      let postData = { financialYear, school_name, state, district };
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
          <h2> Impact of<span className="hdngBrkr"> Energy Efficiency</span>  Measures</h2>
        </div>
      </section>
      <section className="sevenScopeSec reduceWasteSec aboutUsSec impactEnergySec mb-5">
        <div className="container">
          <span className="contact__shape-1"></span>
          <div className="impactEnergDivTab">
            <div className="backBtndiv">
            <button className="button green btn-login-signup loginBtnnewhm impctBtn" onClick={()=>navigate(-1)} >Back</button>
            </div>
            <div className="dashbrdTopSrchDiv">
              <div className="row">
                <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-2">
                  <div className="card-stats card">
                    <select name="financialYear" className="form-control" onChange={(e) => setFinancialYear(e.target.value)}>
                      <option value="">Select Financial Year</option>
                      <option value="2024-25">2024-25</option>
                      <option value="2023-24">2023-24</option>
                      <option value="2022-23">2022-23</option>
                    </select>
                  </div>
                </div>
                <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="card-stats card">
                    <select name="state" className="form-control" onChange={(e) => handleSelectState(e.target.value)}>
                      <option value="">Select State</option>
                      {StateList.map((list, i) => (
                        <option key={i} value={list.state_id}>{list.state_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="card-stats card">
                    <select name="district" className="form-control" onChange={(e) => { handleSelectDistrict(e.target.value) }}>
                      <option value="">Select District</option>
                      {filterDistrict.map((list, i) => (
                        <option key={i} value={list.district_name}>{list.district_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                  <div className="card-stats card">
                    <select name="school_name" className="form-control" value={school_name} onChange={(e) => setSchoolName(e.target.value)}>
                      <option value="">Select School</option>
                      {filteredSchool && filteredSchool.map((school, i) => (
                        <option key={i} value={school.school_name}>{school.school_name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="srchBx _sr1 srchBtn col-12 col-sm-6 col-md-6 col-lg-1">
                  <button type="submit" className="button green btn-login-signup loginBtnnewhm hdrBtnSrch" onClick={() => handleSubmit()}>Search</button>
                </div>
              </div>
            </div>
            <div className="selectFina">
              <h3 className="frYrHdng">For The Year 2018-19</h3>
            </div>
            <ul className="d-flex justify-content-between">
              <li>
                <div className="impctBoxOne impctBoxoneDivttl">
                  Total Energy Consumed more than 223 000 TWh
                </div>
              </li>
              <li>
                <div className="impctBoxOne impctBoxoneDiv">
                  Total Energy Savings of 23.73 Mtoe
                </div>
              </li>
              <li>
                <div className="impctBoxOne impctBoxTow">
                  Monetary Savings of INR 89,122 Crore
                </div>
              </li>
              <li>
                <div className="impctBoxOne impctBoxThree">
                  Emission Reductions of 151.74 Million tonnes of CO2
                </div>
              </li>
            </ul>
          </div>
          <div className="topExprtCnt"> Update at 5 May 2024 05:58 PM <span><PiExportBold /> Export</span></div>
          <div className="impactEnergyDivCnt">
            <LineChart />
            <div className="chart-legend"><span className="dotOne dotenrgy"><GoDotFill /></span> Total Energy Consumed<span className="dotOne"><GoDotFill /></span> Energy Savings  <span className="dotOne dotTwo"><GoDotFill /></span> Monetary Savings <span className="dotOne dotTwo dotThree"><GoDotFill /></span> Emission Reductions</div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ImpactEnergy;
